module.exports = __webpack_public_path__ + "img/question-left-sp.5b5c479.png";